<div class="p-4 md:p-6">
  <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-6">
    <div>
      <h1 class="text-xl font-bold text-gray-900">Campaigns</h1>
      <p *ngIf="view === 'leaderboard'" class="text-sm text-gray-500">
        Meta ads ranked by leads, pickups and revenue, across WhatsApp and website CTAs. Dates are IST days.
        <a routerLink="/marketing/acquisition" class="text-green-700 hover:underline">All channels in Acquisition</a>
      </p>
      <p *ngIf="view === 'previous'" class="text-sm text-gray-500">Previous view: WhatsApp ad-attributed traffic only, with lifetime spend.</p>
    </div>
    <div class="inline-flex rounded-md border border-gray-300 overflow-hidden self-start" role="group" aria-label="Campaigns view">
      <button type="button" (click)="selectView('leaderboard')" [attr.aria-pressed]="view === 'leaderboard'"
        class="px-3 py-2 text-sm font-semibold"
        [class.bg-green-600]="view === 'leaderboard'" [class.text-white]="view === 'leaderboard'"
        [class.bg-white]="view !== 'leaderboard'" [class.text-gray-700]="view !== 'leaderboard'">
        <i class="fas fa-trophy mr-1"></i> Ad leaderboard
      </button>
      <button type="button" (click)="selectView('previous')" [attr.aria-pressed]="view === 'previous'"
        class="px-3 py-2 text-sm font-semibold border-l border-gray-300"
        [class.bg-green-600]="view === 'previous'" [class.text-white]="view === 'previous'"
        [class.bg-white]="view !== 'previous'" [class.text-gray-700]="view !== 'previous'">
        <i class="fas fa-history mr-1"></i> Previous view
      </button>
    </div>
  </div>

  <!-- Filters -->
  <div class="bg-white rounded-lg border border-gray-200 p-4 mb-6">
    <div class="flex flex-wrap items-end gap-4">
      <div>
        <label class="block text-xs font-semibold text-gray-500 uppercase mb-1">From</label>
        <app-date-input [(ngModel)]="fromDate"></app-date-input>
      </div>
      <div>
        <label class="block text-xs font-semibold text-gray-500 uppercase mb-1">To</label>
        <app-date-input [(ngModel)]="toDate"></app-date-input>
      </div>
      <div *ngIf="view === 'previous'" class="flex-1 min-w-[200px]">
        <label class="block text-xs font-semibold text-gray-500 uppercase mb-1" for="search">Search Ad / Campaign</label>
        <input type="text" id="search" [(ngModel)]="searchText" placeholder="Search by ad or campaign name"
          class="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-green-500">
      </div>
      <div class="flex gap-2">
        <button (click)="applyRange()"
          class="bg-green-600 hover:bg-green-700 text-white text-sm font-semibold px-4 py-2 rounded-md">
          <i class="fas fa-search mr-1"></i> Apply
        </button>
        <button *ngIf="view === 'previous'" (click)="clearFilters()"
          class="bg-gray-100 hover:bg-gray-200 text-gray-700 text-sm font-semibold px-4 py-2 rounded-md">
          <i class="fas fa-times mr-1"></i> Clear
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="view === 'leaderboard' && rangeError" class="bg-red-50 text-red-700 border border-red-200 rounded-md px-4 py-3 mb-4 text-sm">
    <i class="fas fa-exclamation-circle mr-1"></i> {{ rangeError }}
  </div>

  <app-ad-leaderboard *ngIf="view === 'leaderboard' && appliedRange" [range]="appliedRange"></app-ad-leaderboard>

  <ng-container *ngIf="view === 'previous'">
  <!-- Error -->
  <div *ngIf="errorMessage" class="bg-red-50 text-red-700 border border-red-200 rounded-md px-4 py-3 mb-4 text-sm">
    <i class="fas fa-exclamation-circle mr-1"></i> {{ errorMessage }}
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="text-center text-gray-500 py-10">
    <i class="fas fa-spinner fa-spin mr-1"></i> Loading campaigns...
  </div>

  <!-- Table -->
  <div *ngIf="!loading && !errorMessage" class="bg-white rounded-lg border border-gray-200 overflow-x-auto">
    <table class="min-w-full text-sm">
      <thead class="bg-gray-50 border-b border-gray-200">
        <tr>
          <th class="px-4 py-3 text-left font-semibold text-gray-600">Ad</th>
          <th class="px-4 py-3 text-left font-semibold text-gray-600">Campaign</th>
          <th class="px-4 py-3 text-left font-semibold text-gray-600">Ad Set</th>
          <th class="px-4 py-3 text-right font-semibold text-gray-600">Spend</th>
          <th class="px-4 py-3 text-right font-semibold text-gray-600">Leads</th>
          <th class="px-4 py-3 text-right font-semibold text-gray-600">Signed Up</th>
          <th class="px-4 py-3 text-right font-semibold text-gray-600">Pickup Booked</th>
          <th class="px-4 py-3 text-right font-semibold text-gray-600">Pickup Completed</th>
          <th class="px-4 py-3 text-right font-semibold text-gray-600">Cost Per Lead</th>
          <th class="px-4 py-3 text-right font-semibold text-gray-600">Cost Per Signup</th>
          <th class="px-4 py-3 text-right font-semibold text-gray-600">Cost Per Booking</th>
          <th class="px-4 py-3 text-right font-semibold text-gray-600">Cost Per Completed Pickup</th>
          <th class="px-4 py-3 text-right font-semibold text-gray-600">Revenue Generated</th>
          <th class="px-4 py-3 text-right font-semibold text-gray-600">ROAS</th>
        </tr>
      </thead>
      <tbody>
        <!-- Pinned Direct/Organic row — not part of the paginated ad set (no Spend, ROAS undefined) -->
        <tr *ngIf="directRow" class="border-b-2 border-gray-200 bg-gray-50/70">
          <td class="px-4 py-3 font-medium text-gray-900">
            {{ directRow.adName }}
            <span class="ml-2 inline-block px-2 py-0.5 text-xs font-semibold text-gray-500 bg-gray-200 rounded-full">Organic</span>
          </td>
          <td class="px-4 py-3 text-gray-400">—</td>
          <td class="px-4 py-3 text-gray-400">—</td>
          <td class="px-4 py-3 text-right text-gray-400">—</td>
          <td class="px-4 py-3 text-right">{{ directRow.leads }}</td>
          <td class="px-4 py-3 text-right">{{ directRow.signedUp }}</td>
          <td class="px-4 py-3 text-right">{{ directRow.pickupsBooked }}</td>
          <td class="px-4 py-3 text-right">{{ directRow.pickupsCompleted }}</td>
          <td class="px-4 py-3 text-right text-gray-400">—</td>
          <td class="px-4 py-3 text-right text-gray-400">—</td>
          <td class="px-4 py-3 text-right text-gray-400">—</td>
          <td class="px-4 py-3 text-right text-gray-400">—</td>
          <td class="px-4 py-3 text-right text-gray-400">—</td>
          <td class="px-4 py-3 text-right text-gray-400">N/A</td>
        </tr>
        <tr *ngFor="let ad of ads" class="border-b border-gray-100 hover:bg-gray-50">
          <td class="px-4 py-3 font-medium text-gray-900">{{ ad.adName || ad.adId }}</td>
          <td class="px-4 py-3 text-gray-600">{{ ad.campaignName || '—' }}</td>
          <td class="px-4 py-3 text-gray-600">{{ ad.adsetName || '—' }}</td>
          <td class="px-4 py-3 text-right">{{ ad.spend | number:'1.2-2' }}</td>
          <td class="px-4 py-3 text-right">{{ ad.leads }}</td>
          <td class="px-4 py-3 text-right">{{ ad.signedUp }}</td>
          <td class="px-4 py-3 text-right">{{ ad.pickupsBooked }}</td>
          <td class="px-4 py-3 text-right">{{ ad.pickupsCompleted }}</td>
          <td class="px-4 py-3 text-right">{{ ad.costPerLead != null ? (ad.costPerLead | number:'1.2-2') : '—' }}</td>
          <td class="px-4 py-3 text-right">{{ ad.costPerSignUp != null ? (ad.costPerSignUp | number:'1.2-2') : '—' }}</td>
          <td class="px-4 py-3 text-right">{{ ad.costPerBooking != null ? (ad.costPerBooking | number:'1.2-2') : '—' }}</td>
          <td class="px-4 py-3 text-right">{{ ad.costPerAcquisition != null ? (ad.costPerAcquisition | number:'1.2-2') : '—' }}</td>
          <td class="px-4 py-3 text-right">{{ ad.companyRevenue | number:'1.2-2' }}</td>
          <td class="px-4 py-3 text-right font-semibold"
            [ngClass]="{ 'text-green-600': (ad.roas ?? 0) >= 1, 'text-red-500': (ad.roas ?? 0) < 1 && ad.roas != null }">
            {{ ad.roas != null ? (ad.roas | number:'1.2-2') : '—' }}
          </td>
        </tr>
        <tr *ngIf="ads.length === 0 && !directRow">
          <td colspan="14" class="px-4 py-10 text-center text-gray-400">No ad performance data for the selected filters.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <app-pagination *ngIf="!loading && !errorMessage && totalCount > 0"
    [page]="currentPage" [totalPages]="totalPages" [pageSize]="pageSize"
    (pageChange)="onPageChange($event)" (pageSizeChange)="onPageSizeChange($event)">
  </app-pagination>
  </ng-container>
</div>
